import axios from 'axios';
import { browserHistory } from 'react-router';
import { SubmissionError } from 'redux-form'

import {
    REQUEST_SCRAP_RECORDS,
    FETCH_SCRAP_RECORDS_SUCCESS,
    FETCH_SCRAP_RECORDS_FAILURE,
    SELECT_SCRAP_RECORD,
    RESET_CURRENT_SCRAP_RECORD,
    REQUEST_SCRAP_RECORD_DETAIL,
    FETCH_SCRAP_RECORD_DETAIL_SUCCESS,
    FETCH_SCRAP_RECORD_DETAIL_FAILURE,
    FETCH_INVENTORY_SCRAP,
    FETCH_INVENTORY_SCRAP_SUCCESS,
    FETCH_INVENTORY_SCRAP_FAILURE,
    REQUEST_CREATING_SCRAP_RECORD,
    CREATE_SCRAP_RECORD_SUCCESS,
    CREATE_SCRAP_RECORD_FAILURE,
    REQUEST_EDITING_SCRAP_RECORD,
    EDIT_SCRAP_RECORD_SUCCESS,
    EDIT_SCRAP_RECORD_FAILURE
} from './type'

import {
    SCRAP_RECORDS_URL,
    INVENTORY_SCRAP_URL
} from './url';


// ScrapRecords Actions
import { DEFAULT_ERROR } from '../components/Common/constants';
import { isGGI } from './root_url'

export function fetchScrapRecords() {
    return dispatch => {
        dispatch({ type: REQUEST_SCRAP_RECORDS });
        return axios.get(SCRAP_RECORDS_URL,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchScrapRecordsSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchScrapRecordsFailure(err));                          
              }
            });
    }
}

export function fetchScrapRecordsSuccess(scrapRecords) {
    return {
        type: FETCH_SCRAP_RECORDS_SUCCESS,
        payload: scrapRecords
    };
}

export function fetchScrapRecordsFailure(error) {
    return {
        type: FETCH_SCRAP_RECORDS_FAILURE,
        payload: error
    };
}

export function selectScrapRecord(scrapRecord) {
    return {
        type: SELECT_SCRAP_RECORD,
        payload: scrapRecord
    };
}

export function resetCurrentScrapRecord() {
    return {
        type: RESET_CURRENT_SCRAP_RECORD
    }
}


export function fetchScrapRecordDetail(scrapRecord_id) {
    return dispatch => {
        dispatch({ type: REQUEST_SCRAP_RECORD_DETAIL });
        return axios.get(SCRAP_RECORDS_URL + scrapRecord_id,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchScrapRecordDetailSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchScrapRecordDetailFailure(err));                             
              }
            });
    }
}

export function fetchScrapRecordDetailSuccess(scrapRecordDetail) {
    return {
        type: FETCH_SCRAP_RECORD_DETAIL_SUCCESS,
        payload: scrapRecordDetail
    };
}

export function fetchScrapRecordDetailFailure(error) {
    return {
        type: FETCH_SCRAP_RECORD_DETAIL_FAILURE,
        payload: error
    };
}


export function fetchInventoryScrap(productNum) {
    return dispatch => {
        dispatch({ type: FETCH_INVENTORY_SCRAP });
        return axios.get(INVENTORY_SCRAP_URL + productNum,
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            })
            .then(response => {
              dispatch(fetchInventoryScrapSuccess(response));
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(fetchInventoryScrapFailure(err));                             
              }
            });
    }
}

export function fetchInventoryScrapSuccess(inventories) {
    return {
        type: FETCH_INVENTORY_SCRAP_SUCCESS,
        payload: inventories
    };
}

export function fetchInventoryScrapFailure(error) {
    return {
        type: FETCH_INVENTORY_SCRAP_FAILURE,
        payload: error
    };
}

export function createScrapRecord(
  formProps,
  Warehouse_id,
  Warehouse_Scrap_Line) {
    let PostingDate = formProps.PostingDate;
    if (PostingDate) PostingDate = new Date(PostingDate);
    else PostingDate = new Date;
    Warehouse_Scrap_Line.map(line => {
      line['WarehouseBin_id'] = line.WarehouseBin_id;
      line['WarehouseZone_id'] = line.WarehouseZone_id;
    })
    return dispatch => {
        dispatch({ type: REQUEST_CREATING_SCRAP_RECORD });
        axios.post(SCRAP_RECORDS_URL,
            {
              PostingDate,
              Warehouse_id,
              Warehouse_Scrap_Line
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(createScrapRecordSuccess());
              browserHistory.push('/scrapRecords');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(createScrapRecordFailure(err));                             
              }
            });
    }
}

export function createScrapRecordSuccess() {
    return {
        type: CREATE_SCRAP_RECORD_SUCCESS
    }
}

export function createScrapRecordFailure(error) {
    return {
        type: CREATE_SCRAP_RECORD_FAILURE,
        payload: error
    }
}

export function editScrapRecord(
  WarehouseScrap_id,
  formProps,
  Warehouse_id,
  Warehouse_Scrap_Line) {
    let PostingDate = formProps.PostingDate;
    if (PostingDate) PostingDate = new Date(PostingDate);
    return dispatch => {
        dispatch({ type: REQUEST_EDITING_SCRAP_RECORD });
        axios.put(SCRAP_RECORDS_URL + WarehouseScrap_id,
            {
              PostingDate,
              Warehouse_id,
              Warehouse_Scrap_Line
            },
            {
                headers: { Authorization: 'Bearer ' + localStorage.getItem('token') }
            }
        )
            .then(response => {
              dispatch(editScrapRecordSuccess());
              browserHistory.push('/scrapRecords');
            }, err => {
              if (err.status === 500 || err.status === 404) {
                err.data = DEFAULT_ERROR;
              }
              if(isGGI && err.status && err.status == 401 && err.data && err.data.detail && err.data.detail == 'Authentication credentials were not provided.'&& !location.href.endsWith('/login')) {
                document.getElementById('tokenInvalid').style.display = 'flex'
              } else {
                dispatch(editScrapRecordFailure(err));                          
              }
            });
    }
}

export function editScrapRecordSuccess() {
    return {
        type: EDIT_SCRAP_RECORD_SUCCESS
    }
}

export function editScrapRecordFailure(error) {
    return {
        type: EDIT_SCRAP_RECORD_FAILURE,
        payload: error
    }
}



// WEBPACK FOOTER //
// ./master/jsx/actions/scrapRecords_actions.js